import { StepperContextProvider } from "./context";
import Frame from "./frame";

export default {
  Provider: StepperContextProvider,
  Frame,
};
